import { ClassNames } from '@emotion/core';
import Chevron from '@ep/images/chevron.svg';
import MuiFormControl from '@mui/material/FormControl';
import MuiFormHelperText from '@mui/material/FormHelperText';
import MuiInputLabel from '@mui/material/InputLabel';
import MuiSelect, { SelectProps as MuiSelectProps } from '@mui/material/Select';
import React from 'react';

export type SelectSize = 'small' | 'medium';

export interface SelectProps extends Omit<MuiSelectProps, 'variant'> {
  label?: string;
  helperText?: string;
  size: SelectSize;
}

function Select({ id, label, size, error, helperText, ...rest }: SelectProps) {
  const labelId = `${id}-label`;

  return (
    <ClassNames>
      {({ css }) => (
        <MuiFormControl error={error} variant="filled">
          {label && <MuiInputLabel id={labelId}>{label}</MuiInputLabel>}
          <MuiSelect
            labelId={labelId}
            id={id}
            IconComponent={Chevron}
            classes={
              size === 'small'
                ? {
                    select: css`
                      height: 48px;
                    `,
                    // selectMenu: [css],
                  }
                : undefined
            }
            {...rest}
          />
          {helperText && <MuiFormHelperText>{helperText}</MuiFormHelperText>}
        </MuiFormControl>
      )}
    </ClassNames>
  );
}

Select.defaultProps = {
  size: 'medium',
};

export default Select;
